package ir.alirezaivaz.finglish

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.tooling.preview.Preview
import ir.alirezaivaz.finglish.ui.MainScreen
import ir.alirezaivaz.finglish.ui.theme.FinglishTheme
import ir.alirezaivaz.finglish.utils.LocalAppLocale
import ir.alirezaivaz.finglish.utils.SettingsManager

@Composable
@Preview
fun App() {
    val settings = SettingsManager
    val language by settings.language.collectAsState()
    CompositionLocalProvider(
        LocalAppLocale provides language,
        LocalLayoutDirection provides language.direction
    ) {
        key(language) {
            FinglishTheme {
                MainScreen()
            }
        }
    }
}
